import api from "../api";

export const fetchWatomsWorkshopPerformanceReport = async ({ vtcs, workshops }) => {
    try {
        const response = await api.get(
            "/api/v1/watoms/workshop-performance-report",
            {
                params: {
                    vtcs: vtcs || "",
                    workshops: workshops || "",
                },
            }
        );

        return response.data.report || {};
    } catch (error) {
        console.error(
            "Error fetching report:",
            error.response?.data || error.message
        );
        throw error;
    }
};